(function (app, ng) {

    app.controller("addContactController", addContactController);

    addContactController.$inject = ["$mdDialog", "figToaster", "marketingTrackerContactApi"];
    function addContactController($mdDialog, figToaster, marketingTrackerContactApi) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                close: close,
                addContact: addContact,
                contact: { Origin: 'Manual' }
            });

        function addContact(contact) {
            $ctrl.loadingData = true;

            if ($ctrl.form.$valid) {
                marketingTrackerContactApi.addContact(contact)
                    .then(function (response) {
                        $mdDialog.hide(response);
                    })
                    .catch(function (reason) {
                        if (reason) {
                            toastMessage = reason.data;
                        } else {
                            toastMessage = "There was a problem adding your contact. Please try again shortly.";
                        }

                        toastClass = "is-error";
                        figToaster.showSimple(toastMessage, "top", toastClass);
                    })
                    .finally(function () {
                        $ctrl.loadingData = false;
                    });
            }
        }

        function close() {
            $mdDialog.cancel();
        }
    }

})(window.app, window.angular); //jshint ignore:line